import type { ListOpsAuditQuery, ListOpsAuditResponse } from '@nadoutong/contracts';
import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { useSession } from '../hooks/useSession.tsx';
import { listOpsAudit } from './audit.ts';

/**
 * React Query wrapper for the audit log read endpoint.
 *
 * Query key includes the full filter tuple so distinct filter
 * combinations don't alias each other in the cache. The query is
 * read-only (there are no write hooks) so no invalidation
 * orchestration is needed.
 */

export const AUDIT_ROOT_KEY = ['audit'] as const;

export function auditListQueryKey(
  query: ListOpsAuditQuery,
): readonly ['audit', ListOpsAuditQuery] {
  return ['audit', query] as const;
}

export function useAuditList(
  query: ListOpsAuditQuery,
): UseQueryResult<ListOpsAuditResponse> {
  const { fetchImpl } = useSession();
  return useQuery({
    queryKey: auditListQueryKey(query),
    queryFn: ({ signal }) => listOpsAudit(query, fetchImpl, signal),
  });
}
